import { useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import locale from "date-fns/locale/en-US";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";

import AgentHierarchyModal from "../../agentTileFiles/AgentHierarchyModal";
import AgentTileInfo from "../agentTile/AgentTileInfo";
import AgentsColumns from "./AgentsColumns";
import classes from "../../../components/DataGridTemplate/DataGridTemplate.module.css";
import StripedDataGridTemplate from "../../../components/DataGridTemplate/StripedDataGridTemplate";
import AgentsData from "./AgentsData";

const Agents = (props) => {
  const filteredData = props.data;
  const [openAH, setOpenAH] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [currentAgentId, setCurrentAgentId] = useState("");
  const [uplineArr, setUplineArr] = useState([]);
  const { agentsContractInfoData, isAgentDataLoading } = props;
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    agentId: false,
  });
  const filterModel = useSelector(
    (state) => state.agentsContractInfo.filterModel
  );

  const handleUplineClick = useCallback((event, cellValues) => {
    if (cellValues === undefined) {
      setAgentName("");
      setCurrentAgentId("");
    } else {
      setAgentName(cellValues.row.agentName);
      setCurrentAgentId(cellValues.row.agentId);
    }
    setOpenAH((prevOpenAH) => !prevOpenAH);
  }, []);

  const columns = AgentsColumns({ handleUplineClick });
  const uniqueRows = AgentsData({
    data: filteredData,
  });

  const CustomToolbar = useMemo(
    () => () => {
      const sxToolBarContainer = { fontSize: 12, paddingBottom: 1 };
      const sxToolBarColumnsButton = {
        color: "black",
        backgroundColor: "whitesmoke",
      };

      return (
        <GridToolbarContainer sx={sxToolBarContainer}>
          <GridToolbarFilterButton sx={sxToolBarColumnsButton} />
          <GridToolbarExport sx={sxToolBarColumnsButton} />
        </GridToolbarContainer>
      );
    },
    []
  );
  const StripedDataGrid = StripedDataGridTemplate();

  const sxBox = {
    height: 640,
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "rgba(27, 133, 243, 0.8)",
    },
  };

  const paginationProps = {
    pagination: true,
    pageSize: 25,
    rowsPerPageOptions: [25, 50, 100],
  };

  const getDetailPanelHeight = useCallback(() => 400, []);
  const getContent = useCallback(
    (row) => {
      return (
        <AgentTileInfo
          agentId={row.agentId}
          agentsContractInfoData={agentsContractInfoData}
        />
      );
    },
    [agentsContractInfoData]
  );
  // Add a debug log to verify filteredData is being updated
  // useEffect to log whenever filteredData changes
  // This helps confirm the Levels filter is triggering
  // Remove if not needed
  // useEffect(() => {
  //   console.log('Agents.jsx filteredData:', filteredData);
  // }, [filteredData]);

  // filteredData is passed from props, so ensure parent (AgentInfo.jsx) always updates it when checkedLevelValues changes
  return (
    <div className={classes.myClass}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={locale}
      >
        <Box sx={sxBox}>
          <StripedDataGrid
            slots={{                
              toolbar: CustomToolbar,
            }}
            loading={isAgentDataLoading}
            rows={uniqueRows}
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            pagination={paginationProps}
            disableRowSelectionOnClick
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            sx={{ flex: 1 }}
            rowThreshold={0}
            getDetailPanelContent={({ row }) => getContent(row)}
            getDetailPanelHeight={getDetailPanelHeight}
            density="compact"
            initialState={{
              filter: {
                filterModel: filterModel,
              },
            }}
          />
        </Box>
      </LocalizationProvider>
      {openAH === true && (
        <AgentHierarchyModal
          currentAgentId={currentAgentId}
          openAH={openAH}
          toggleAH={handleUplineClick}
          agentName={agentName}
          uplineArr={uplineArr}
          setUplineArr={setUplineArr}
        />
      )}
    </div>
  );
}
// };

export default Agents;
